import { DeviceServiceImplFactory } from "../../core/impl/deviceServiceImpl";

type IDeviceServiceInstance = ReturnType<typeof DeviceServiceImplFactory>;

export const DeviceControllerFactory = ({
  deviceService,
}: {
  deviceService: IDeviceServiceInstance;
}) => {
  return {
    getDeviceConnectionStatus: deviceService.getDeviceConnectionStatus,
  };
};
